import { render, staticRenderFns } from "./dragFormItem.vue?vue&type=template&id=21acf16b&"
import script from "./dragFormItem.vue?vue&type=script&lang=js&"
export * from "./dragFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports